module.exports = __webpack_public_path__ + "img/join_store_white.a6a5977f.svg";